// client/src/helpers.ts
export type MouseClickEvent<T> = MouseEvent & {target: T}

export type Option<T> = { kind: 'none' } | { kind: 'some'; value: T }

export function Option<T>(value: T): Option<T> {
  if (!value) return { kind: 'none' }

  return {
    kind: 'some',
    value: value
  }
}

export function toRelativeUrl(url: string): string {
  let relative: string = url.replace(`${window.location.protocol}//`, '')
  return relative.indexOf('/') > 0 ? relative.substr(relative.indexOf('/')) : relative
}

export function decodeHTMLEntities(html: string): string {
  let output: Element = document.createElement('div')
  output.innerHTML = html
  return output.textContent
}

export type ViewPortSize = 'mobile' | 'tablet' | 'desktop'

export function resizeImage(url: string, width: number, height: number): string {
  // Implement resize
  return url
}

export type gtmHash<T> = { [key: string]: T }

type gtmType = {
  event?: string
  category?: string
  label?: string
  action?: string
}

export function gtmPush(data: gtmType) {
  let defaultData: gtmHash<string> = {
    event: 'event.frieslandcampina_corporate',
    category: '',
    label: window.location.pathname,
    action: ''
  }

  if (window.dataLayer) {
    window.dataLayer.push({ ...defaultData, ...data });
  } else {
    console.log({ ...defaultData, ...data });
  }
}

export function optimizeActivate() {
  let defaultData: gtmHash<string> = {
    event: 'optimize.activate'
  }

  if (window.dataLayer) {
    window.dataLayer.push({ ...defaultData });
  } else {
    console.log({ ...defaultData });
  }
}